module.exports = __webpack_public_path__ + "img/tasks.47257cf5.svg";